import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, Spinner, FormGroup, Label, Input } from "reactstrap";
import { useSelector } from "react-redux";
import Select from 'react-select';

const AgentModal = ({
  show,
  setShow,
  onConfirmClick,
  selectedRow, // The user object being activated/deactivated
  setSelectedRow,
  title,
  description,
  confirmBtnText,
  loading = false,
}) => {
  const { t, i18n } = useTranslation();

  const {isLoading, humanCategories} = useSelector(
    (state) => ({
      isLoading: state.HumanCategories.loading,
      humanCategories: state.HumanCategories.humanCategories,
    })
  );

  const handleClose = () => {
    setShow(false);
  };

  const handleSelect = (selectedOptions) => {
    const ids = selectedOptions ? selectedOptions.map(opt => opt.value) : [];

    setSelectedRow(prev => ({
      ...prev,
      HumanServiceIDs: ids
    }));
  };

  return (
    <Modal isOpen={show} centered={true}>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-start">
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>{t(title)}</h4> 
            {/* <p className="text-muted mx-4 mb-0">{t(description)}</p> */}

            {/* <FormGroup style={{ marginBottom: 8 }}> */}
              <Label style={{ fontWeight: 600, fontSize: 14 }}>{t('Human Service')}</Label>
              {/* <Input
                multiple 
                type="select"
                className="form-select mb-3"
                value={selectedRow.HumanServiceIDs || []}
                onChange={(e) => {
                    const selectedValues = Array.from(e.target.selectedOptions, option => option.value);
                    setSelectedRow((prev) => ({
                        ...prev,
                        HumanServiceIDs: selectedValues
                    }))
                }}
                >
                <option value="">{t("Select")}</option>
                {humanCategories?.map((item) => (
                    <option value={item.ID} key={item.ID}>
                        {i18n.language === 'en' ? item.TitleEn: item.TitleAr}
                    </option>
                ))}
                </Input> */}
              <Select
                isMulti 
                styles={{
                  multiValueLabel: (base) => ({
                    ...base,
                    color: "white", // text color of selected option
                  }),
                }}
                options={(humanCategories || []).map((item) => ({
                  value: item.ID,
                  label: i18n.language === 'ar' ? item.TitleAr : item.TitleEn
                }))}
                value={(humanCategories || [])
                  .filter((item) => (selectedRow.HumanServiceIDs || []).includes(item.ID))
                  .map((item) => ({
                    value: item.ID,
                    label: i18n.language === 'ar' ? item.TitleAr : item.TitleEn
                  }))}
                onChange={handleSelect}
                placeholder={t("select")}
                isLoading={isLoading}
                noOptionsMessage={() => t("NoOptions")}
              />
              
            {/* </FormGroup> */}
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light"
            data-bs-dismiss="modal"
            onClick={handleClose}
          >
            {t("Close")}
          </button>
          <button
            type="button"
            className={`btn w-sm btn-success d-flex align-items-center justify-content-center`}
            id="confirm-toggle-status"
            onClick={onConfirmClick}
            disabled={loading || (selectedRow.HumanServiceIDs || []).length == 0}
          >
            {isLoading && (
              <Spinner
                size="sm"
                style={{
                  marginRight: "10px",
                }}
              >
                {" "}
              </Spinner>
            )}
            {t(confirmBtnText)}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

AgentModal.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  onConfirmClick: PropTypes.func.isRequired,
  item: PropTypes.object, // Can be null initially
  title: PropTypes.string,
  description: PropTypes.string,
  confirmBtnText: PropTypes.string,
  loading: PropTypes.bool,
};

export default AgentModal;